<template>
    <div class="relative overflow-hidden h-full">
        <transition :name="transitionClass">
            <photos-grid-component
                :photos="photoList"
                :page="page"
                :key="page"
                @zoom="zoom"
            ></photos-grid-component>
        </transition>

        <div class="absolute top-0 left-11 inset-y-0 flex items-center">
            <div
                class="h-7 w-7 cursor-pointer"
                :class="buttonClasses"
                @click="previousPage"
            >
                <span class="icon-np-arrow-back"></span>
            </div>
        </div>

        <div class="absolute top-0 right-11 inset-y-0 flex items-center">
            <div
                class="h-7 w-7 cursor-pointer"
                :class="buttonClasses"
                @click="nextPage"
            >
                <span class="icon-np-arrow-forward"></span>
            </div>
        </div>
    </div>
</template>

<style scoped>
.slide-from-right-leave-active,
.slide-from-right-enter-active,
.slide-from-left-leave-active,
.slide-from-left-enter-active {
    transition: 0.8s;
}
.slide-from-right-enter-from,
.slide-from-left-leave-to {
    transform: translate(100%, 0);
}
.slide-from-right-leave-to,
.slide-from-left-enter-from {
    transform: translate(-100%, 0);
}
</style>

<script>
import PhotosGridComponent from "@/Components/Vehicle/Photos-Grid.vue";

export default {
    components: {
        PhotosGridComponent,
    },
    props: {
        photos: {
            type: Array,
            required: true,
        },
    },
    data() {
        return {
            page: 0,
            photoList: [],
            defaultPhoto: "/images/photos-soon.jpg",
            transitionClass: "slide-from-right",
            buttonClasses: [
                "rounded-full",
                "flex",
                "items-center",
                "justify-center",
                "text-white",
                "hover:text-primary",
                "bg-primary",
                "hover:bg-white",
                "transition",
                "duration-500",
                "ease-in-out",
            ],
        };
    },
    mounted() {
        this.photoList = this.photos.slice(1);
    },
    methods: {
        nextPage() {
            this.transitionClass = "slide-from-right";
            if (this.photoList.length - (this.page + 1) * 4 > 0) {
                this.page++;
            } else {
                this.page = 0;
            }
        },
        previousPage() {
            this.transitionClass = "slide-from-left";
            if (this.page > 0) {
                this.page--;
            } else {
                this.page = Math.floor(this.photoList.length / 4);
            }
        },
        zoom(index) {
            // since the first photo is removed when passing the array of photos
            // to photos grid component, so index has to be increased by 1 so
            // that the first photo could be included in
            this.$emit("zoom", this.photos, index + 1);
        },
    },
};
</script>
